import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import { CITIES } from "@/data/landingConfig";

const cities = Object.values(CITIES)
  .map((city) => ({ slug: city.slug, label: city.nomeEsteso }))
  .sort((a, b) => a.label.localeCompare(b.label, "it"));

const serviceGroups = [
  { slug: "pulizie-appartamenti-vacanze", label: "Appartamenti vacanze" },
  { slug: "pulizie-enti-pubblici", label: "Enti pubblici" },
  { slug: "sanificazione-attivita-commerciali", label: "Sanificazione attività" },
  { slug: "pulizie-post-cantiere", label: "Post cantiere" },
  { slug: "pulizie-supermercati-ristoranti", label: "Supermercati e ristoranti" },
  { slug: "pulizie-uffici-aziende", label: "Uffici e aziende" },
];

const zoneLinks = cities.map((city) => ({ to: `/aziende/pulizie/${city.slug}`, label: city.label }));

export default function Footer() {
  const { t, tx } = useI18n();
  const linkCls = "transition-colors hover:text-slate-950";
  const headingCls = "mb-3 text-xs font-semibold uppercase tracking-wider text-slate-900";
  const serviceHeadingCls = "text-sm font-semibold text-slate-900";

  return (
    <footer className="border-t border-slate-200/70 bg-white/72 backdrop-blur-xl">
      <div className="container mx-auto px-4 py-8 sm:px-6 sm:py-10">
        <div className="grid gap-8 text-sm text-slate-600 sm:grid-cols-2 lg:grid-cols-3">
          <nav aria-label="Halomora">
            <div className={headingCls}>Halomora</div>
            <ul className="space-y-2">
              <li><Link to="/" className={linkCls}>Home</Link></li>
              <li><Link to="/faq" className={linkCls}>{t('footer.faq', 'FAQ')}</Link></li>
              <li><Link to="/status" className={linkCls}>{t('footer.status', 'Status')}</Link></li>
            </ul>
          </nav>

          <nav aria-label={t('footer.col.business', 'Per le imprese')}>
            <div className={headingCls}>{t('footer.col.business', 'Per le imprese')}</div>
            <ul className="space-y-2">
              <li><Link to="/for-businesses" className={linkCls}>{t('footer.for_businesses', 'Diventa partner')}</Link></li>
              <li><Link to="/for-businesses/booking-system-demo" className={linkCls}>{t('footer.demo', 'Esempi sito + booking')}</Link></li>
              <li><Link to="/apartment-manager/partner-pulizie" className={linkCls}>{t('footer.apartment_manager', 'Per i property manager')}</Link></li>
            </ul>
          </nav>

          <nav aria-label={t('footer.col.zones', 'Aziende per zona')}>
            <div className={headingCls}>{t('footer.col.zones', 'Aziende per zona')}</div>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
              {zoneLinks.map((l) => (
                <li key={l.to}><Link to={l.to} className={linkCls}>{l.label}</Link></li>
              ))}
            </ul>
          </nav>
        </div>

        <nav aria-label={t('footer.col.services', 'Servizi di pulizia')} className="mt-10 border-t border-slate-200/70 pt-8 text-sm text-slate-600">
          <div className={headingCls}>{t('footer.col.services', 'Servizi di pulizia')}</div>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {serviceGroups.map((service) => (
              <section key={service.slug} className="rounded-2xl border border-slate-200/70 bg-white/55 p-4">
                <h3 className={serviceHeadingCls}>{service.label}</h3>
                <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2">
                  {cities.map((city) => (
                    <li key={`${service.slug}-${city.slug}`}>
                      <Link to={`/servizi/${service.slug}/${city.slug}`} className={linkCls}>{city.label}</Link>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </div>
        </nav>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-slate-200/70 pt-5 text-xs text-slate-500 md:flex-row">
          <div>{tx('footer.rights', { year: new Date().getFullYear() })}</div>
          <nav aria-label="Legal" className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:gap-x-4">
            <Link to="/legal/privacy" className={linkCls}>{t('footer.privacy', 'Privacy')}</Link>
            <Link to="/legal/terms" className={linkCls}>{t('footer.terms', 'Terms')}</Link>
            <Link to="/legal/cookies" className={linkCls}>{t('footer.cookies', 'Cookies')}</Link>
            <Link to="/legal/imprint" className={linkCls}>{t('footer.imprint', 'Imprint')}</Link>
            <Link to="/legal/subprocessors" className={linkCls}>{t('footer.subprocessors', 'Subprocessors')}</Link>
            <button onClick={() => (window as any).openCookiePreferences?.()} className={linkCls}>{t('footer.cookie_preferences', 'Cookie Preferences')}</button>
          </nav>
        </div>
      </div>
    </footer>
  );
}
